import { render, staticRenderFns } from "./AAsignacionTablaPro.vue?vue&type=template&id=2a678b92"
import script from "./AAsignacionTablaPro.vue?vue&type=script&lang=js"
export * from "./AAsignacionTablaPro.vue?vue&type=script&lang=js"
import style0 from "./AAsignacionTablaPro.vue?vue&type=style&index=0&id=2a678b92&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports